import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import { DetailedScenario, ScenarioType } from "@mutiny-group/sbo-openapi-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type ChangeScenarioTypeParams = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioUUID: string;
  scenarioType: ScenarioType;
};

const changeScenarioType = ({
  scenarioBuilderClient,
  scenarioUUID,
  scenarioType,
}: ChangeScenarioTypeParams) => {
  return scenarioBuilderClient.scenarios.changeScenarioType({
    scenarioUuid: scenarioUUID,
    changeScenarioTypeRequest: {
      scenarioType,
    },
  });
};

type ChangeScenarioMutationParams = Omit<ChangeScenarioTypeParams, "scenarioBuilderClient">;

export const useChangeScenarioType = () => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ scenarioUUID, scenarioType }: ChangeScenarioMutationParams) =>
      changeScenarioType({ scenarioBuilderClient, scenarioUUID, scenarioType }),
    onSuccess: ({ uuid }: DetailedScenario) => {
      queryClient.invalidateQueries({ queryKey: ["scenario-v2", uuid] });
      queryClient.invalidateQueries({ queryKey: ["scenario-results-v2", uuid] });
      queryClient.invalidateQueries({ queryKey: ["scenarios-v2"] });
    },
  });
};
